import { createSelector } from 'reselect';
import PaperFreeMonitoringCarrierDetailsColumns
  from '../../containers/PaperFreeMonitoringCarrierDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PaperFreeMonitoringCarrierDetailsTotalColumns
  from '../../containers/PaperFreeMonitoringCarrierDetailsTotalColumns';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_901_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PAPER_FREE_MONITORING_CARRIER_901_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .PAPER_FREE_MONITORING_CARRIER_901_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PaperFreeMonitoringCarrierDetailsColumns);

export const getTotalColumns =
  createSelector(getData, PaperFreeMonitoringCarrierDetailsTotalColumns);
